const geoLocationOptions = {
    enableHighAccuracy: true,
    timeout: 6000,
    maximumAge: 120000,
  };
  
   // @todo update default store Id 
   const defaultStoreId = "06585";
  
  export default { geoLocationOptions, defaultStoreId };
  